module.exports = __webpack_public_path__ + "static/media/T12.e95533b1.jpg";